export const allTheLittleDetailsData = {
  mobileTextBlock: {
    title: 'All the little details, detailed.',
    body: 'A page for all the wedding details your guests need to know, from your first announcement to your last event.',
  },
  blocks: [
    {
      icon: 'schedule',
      title: 'Personalized Schedules',
      body: 'From the rehearsal dinner to the post-wedding brunch, choose who can see and RSVP to what.',
      image: 'wedding-website/static/page-details-schedule-v2.png',
      imageAltText: 'Personalized Schedules',
    },
    {
      icon: 'questionAndAnswer',
      title: 'Helpful Guest Q&A',
      body: `Stop. Answering. The Same. Questions. Create an FAQ for your guests — we'll even give you suggestions to start, from dress code to arrival details.`,
      image: 'wedding-website/static/page-details-qa.png',
      imageAltText: 'Helpful quest Q and A',
    },
    {
      icon: 'travel',
      title: 'Guest Travel Tools',
      body: 'Provide guests with travel information to book their hotel and flight, get a ride, or even find the best spot to grab a bite.',
      image: 'wedding-website/static/page-details-travel.png',
      imageAltText: 'Guest Travel Tools',
    },
    {
      icon: 'registry',
      title: 'All the Registries',
      body: `Whether you’re looking for honeymoon funds, supporting a cause, or yearning for a KitchenAid mixer, put all your wedding registries in one place.`,
      image: 'wedding-website/static/page-details-reg.png',
      imageAltText: 'All the Registries',
    },
    {
      icon: 'story',
      title: 'Share Your Love Story',
      body: `There isn’t always time to tell the tale at the big bash. Warm your guests’ hearts beforehand by publishing your story for all to read.`,
      image: 'wedding-website/static/page-details-story.png',
      imageAltText: 'Share your Love Story',
    },
    {
      icon: 'weddingParty',
      title: 'Wedding Party Bios',
      body: 'Introduce each member of your wedding party with their own photo and details, reducing the who’s who convos for all.',
      image: 'wedding-website/static/page-details-wedding-party.png',
      imageAltText: 'Wedding Party Bios',
    },
  ],
} as const;

export const siteToSeeData = {
  siteToSeeDescription: `Your beautiful engagement photos and artwork will always be crisp, clear, and colorful so your site looks stunning on every screen.`,
  siteToSeeDescriptionMobile: `We’ve made sure your beautiful photos and the art in your website’s design are always crisp, clear, and colorful, so you look good on every screen.`,
};
